import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { AdminUserForm } from '../../interfaces/adminuser-form.interface';

const adminAccessUrlApi = environment.adminAccessUrlApi;
const adminChangePass = environment.adminResetPass;

@Injectable()
export class AdminService {
  public user: AdminUserForm;

  constructor(private http: HttpClient) {}

  getAdminUsers() {
    return this.http
      .request("GET", `${adminAccessUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getAdminUserById(id: number) {
    return this.http
      .request("GET", `${adminAccessUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  changePasswordById(id: number, newPass: string) {
    const body = { newPassword: newPass };
    console.log(body);
    return this.http
      .request("PUT", `${adminChangePass}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

}
